import {
  Flex,
  Text,
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Tag,
  HStack,
  VStack,
  MenuItemProps,
  Button,
  useBreakpointValue,
} from "@chakra-ui/react";
import React, { useContext } from "react";
import { isBrowser } from "react-device-detect";
import { MdLogout } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { FaUserCircle, FaCaretDown } from "react-icons/fa";
import { NavLink } from "react-router-dom";

import { UserContext } from "../../contexts/UserContext";
import { ReactComponent as Dollar } from "../../images/icons/dollar.svg";

import { UpdatingStatus } from "./UpdatingStatus";

export const AccountBar = () => {
  const { logout, userDetails } = useContext(UserContext);

  const showRefer = useBreakpointValue({
    base: false,
    "2xs": true,
    xs: false,
    sm: true,
    md: true,
    lg: true,
    xl: true,
  });

  return (
    <Flex
      w="100%"
      h="40px"
      justifyContent="space-between"
      alignItems="center"
      shrink={0}
      gap="20px"
      pl="10px"
      pr={isBrowser ? { base: "20px", xs: "50px" } : "20px"}
      position="sticky"
      top={0}
      zIndex={1001}
      bgColor="white.500"
      // borderBottom="1px solid white"
    >
      <Flex alignItems="center" shrink={0}>
        <UpdatingStatus />
      </Flex>
      <HStack spacing={5} h="100%" flexShrink={1} overflow="hidden">
        {/*<NavLink to="/affiliate">*/}
        {showRefer && (
          <NavLink to="/affiliate">
            <Button
              py="5px"
              px="10px"
              height="80%"
              bgColor="white.100"
              borderRadius="10px"
              leftIcon={<Dollar fontSize="1.2rem" />}
              color="green.600"
              overflow="hidden"
              textOverflow="ellipsis"
              textAlign="left"
              minW="0px"
              border="1px solid"
            >
              Refer & Earn
            </Button>
          </NavLink>
        )}
        {/*</NavLink>*/}
        <Flex shrink={0}>
          <Menu>
            <MenuButton>
              <Flex direction="row" alignItems="center">
                <Text color="black.800" fontSize="0.875rem">
                  {userDetails?.email}
                </Text>
                <Box pl="10px">
                  <FaUserCircle fontSize="1.2rem" color="#808080" />
                </Box>
                <Box pl="10px">
                  <FaCaretDown color="#808080" />
                </Box>
              </Flex>
            </MenuButton>
            <MenuList p="0" m="10px 10px 0 0">
              <NavLink to={"/settings"}>
                <AccountBarMenuItem icon={<CgProfile fontSize="1.2rem" />}>
                  Profile Settings
                </AccountBarMenuItem>
              </NavLink>
              <NavLink to={"/affiliate"}>
                <AccountBarMenuItem
                  color="green.600"
                  icon={<Dollar fontSize="1.2rem" />}
                >
                  <VStack align="flex-start">
                    <HStack>
                      <Text>Refer and Earn</Text>
                      <Tag bgColor="green.100" color="green.600">
                        New
                      </Tag>
                    </HStack>
                  </VStack>
                </AccountBarMenuItem>
              </NavLink>
              <MenuDivider m="0" />
              <AccountBarMenuItem
                onClick={() => logout()}
                icon={<MdLogout fontSize="1.2rem" />}
              >
                Logout
              </AccountBarMenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </HStack>
    </Flex>
  );
};

const AccountBarMenuItem = (props: MenuItemProps) => (
  <MenuItem
    _focus={{ backgroundColor: "white.0" }}
    _hover={{ backgroundColor: "white.500" }}
    p="10px 0 10px 20px"
    color="black.700"
    fontSize="0.85rem"
    {...props}
  ></MenuItem>
);
